import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

/**
 * Fetches linked artist accounts for the current user.
 * @param {string} userId - The ID of the authenticated user.
 * @returns {Promise<Array>} - A promise that resolves to an array of linked artist accounts.
 */
const fetchLinkedArtistAccounts = async (userId) => {
  const db = getFirestore();
  const artistAccountsRef = collection(db, "artist_accounts");

  try {
    const q = query(artistAccountsRef, where("createdBy", "==", userId));
    const querySnapshot = await getDocs(q);

    const artistAccounts = [];
    querySnapshot.forEach((doc) => {
      artistAccounts.push({ id: doc.id, ...doc.data() });
    });

        // Check for duplicate IDs
        const ids = artistAccounts.map((acc) => acc.id);
        const duplicates = ids.filter((id, index) => ids.indexOf(id) !== index);
        if (duplicates.length > 0) {
          console.error("Duplicate IDs detected:", duplicates);
        }
        
    return artistAccounts;
  } catch (error) {
    console.error("Error fetching linked artist accounts:", error);
    throw new Error("Failed to fetch linked artist accounts.");
  }
};


export default fetchLinkedArtistAccounts;
